import { Pipe, PipeTransform } from '@angular/core';
import { IAirRating } from "libraries/model/air-quote/IQuote";
import { IJourneysRefAndAirRating } from "libraries/service/resources/airTrip/IGetAirTripQuotes";

@Pipe({
    name: 'getYucangooRating'
})
export class GetYucangooRatingPipe implements PipeTransform {

    public transform(ratingArray: IJourneysRefAndAirRating[], selectedJourneys: string[]): IAirRating {
        if (!ratingArray) {
            return null;
        }

        if (!ratingArray.length) {
            return null;
        }
        const keyCompare: string = selectedJourneys.join('-');

        const matchingRatingForJourney: IJourneysRefAndAirRating =
            ratingArray.find((rating: IJourneysRefAndAirRating) => rating.journeyKey === keyCompare);
        return matchingRatingForJourney ? matchingRatingForJourney.rating : null;
    }

}
